import { BrandStore } from '@/app/features/brand';
import { TranslatePipe } from '@ngx-translate/core';

import { RouterOutlet } from '@angular/router';
import { inject, computed, Component } from '@angular/core';

@Component({
  selector: 'app-auth-layout',
  imports: [RouterOutlet, TranslatePipe],
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.scss',
})
export class AuthLayoutComponent {
  protected brandStore: BrandStore = inject(BrandStore);

  protected logo = computed(() => {
    if (this.brandStore.isLoading()) {
      return '';
    }

    if (!this.brandStore.brand()?.auth_logo_url) {
      return '/assets/images/logo.png';
    }

    return this.brandStore.brand()!.auth_logo_url;
  });
}
